import * as types from './types'
export default {
  [types.SET_TWILIO_TOKEN](state, data) {
    state.twilioToken = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/app/mutations.js